export default __webpack_public_path__ + "static/media/figure.ca11a9d5.svg";